'use strict';
import angular from 'angular';
import '../chart/goal/widget.goal.module';
import './accountmanager/widget.accountmanager.module';

angular.module('widget.admin', [
    'widget.accountmanager',
    'widget.goal'
]);